import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-header" }, "Política de cancelamento")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Sessões pagas via boleto não podem ser canceladas. No entanto, é possível realizar o reagendamento, se necessário. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_RadioInput = _resolveComponent("RadioInput")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_FormButton = _resolveComponent("FormButton")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.item?.isCancelable)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Cancelar esta sessão",
              fullWidth: "",
              outline: "",
              outlineColor: "danger",
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(_ctx.modal.id)))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      id: _ctx.modal.id,
      title: _ctx.modal.title,
      backdrop: "false"
    }, {
      body: _withCtx(() => [
        (_ctx.item.recurrency)
          ? (_openBlock(), _createBlock(_component_RadioInput, {
              key: 0,
              model: _ctx.v$.form.cancel_all,
              options: _ctx.cancelAllOptions
            }, null, 8, ["model", "options"]))
          : _createCommentVNode("", true),
        _createVNode(_component_TextInput, {
          required: "",
          label: "Motivo",
          model: _ctx.v$.form.reason_for_cancellation,
          placeholder: "Por que deseja cancelar?"
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          outline: "",
          outlineColor: "primary",
          label: "Não, voltar",
          onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal(_ctx.modal.id)))
        }),
        _createVNode(_component_FormButton, {
          label: "Sim, cancelar esta sessão",
          color: "danger",
          onOnClick: _ctx.handleCancelConfirmed,
          loading: _ctx.submitting,
          disabled: _ctx.v$.$invalid,
          form: _ctx.v$.form
        }, null, 8, ["onOnClick", "loading", "disabled", "form"])
      ]),
      _: 1
    }, 8, ["id", "title"])
  ], 64))
}